/* global */

import React from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import { Layer, Feature, ZoomControl, Popup } from 'react-mapbox-gl';
import ConfiguredMapboxGl, { MapboxStyle } from '../../../helpers/ConfiguredMapboxGl';

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.centerLayout = {
      'icon-image': 'lodging_15',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
    };
    this.markerLayout = {
      'icon-image': 'marker_15',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
    };
    this.boundsOptions = { padding: 20 };
    this.state = {
      centerMapAroundPoints: this.allItemPositions(),
      center: this.centerPointPosition(),
      map: null,
    };
  }

  componentDidMount() {
    this.centerMapAroundItems();
  }

  componentWillReceiveProps(nextProps) {
    const { selectedItemId: currentlySelectedItemId } = this.props;
    const { selectedItemId } = nextProps;

    const haveSelectedItem = !!selectedItemId;
    const newSelectedItemIsDifferentToOld = selectedItemId !== currentlySelectedItemId;

    if (haveSelectedItem && newSelectedItemIsDifferentToOld) {
      this.panToItem(selectedItemId);
    }
  }

  onStyleLoad(map) {
    this.setState({ map });
    this.updateBounds();
  }

  getBounds() {
    const positions = this.allItemPositions();
    const bounds = new mapboxgl.LngLatBounds();
    positions.forEach(position => bounds.extend(position));
    return bounds;
  }

  updateBounds() {
    const { map } = this.state;
    const bounds = this.getBounds();

    if (this.itemsWithPositions().length > 0) {
      map.fitBounds(bounds, this.boundsOptions);
    }
  }

  panToItem(id) {
    const items = this.itemsWithPositions();
    const { map } = this.state;
    const item = items.find(currentItem => currentItem.id === id);
    const centerPosition = this.centerPointPosition();
    const itemPosition = this.itemLngLat(item);
    const bounds = new mapboxgl.LngLatBounds();
    [centerPosition, itemPosition].forEach(position => bounds.extend(position));
    map.fitBounds(bounds, this.boundsOptions);
  }

  itemLngLat(item) {
    return [item.longitude, item.latitude];
  }

  centerPointPosition() {
    const { centerPoint: { latitude, longitude } } = this.props;
    return [longitude, latitude];
  }

  itemsWithPositions() {
    const { items } = this.props;

    return items.filter(item => !!item.latitude);
  }

  allItemPositions() {
    const items = this.itemsWithPositions();

    const latLngsOfItems = items.map(item => this.itemLngLat(item));

    return [this.centerPointPosition()].concat(latLngsOfItems);
  }

  centerMapAroundItems() {
    const items = this.itemsWithPositions();

    if (items.length === 0) { return; }

    this.setState({ centerMapAroundPoints: this.allItemPositions() });
  }

  findActiveItem() {
    const { selectedItemId } = this.props;
    const items = this.itemsWithPositions();

    return items.find(item => item.id === selectedItemId);
  }

  renderMarker(id, position) {
    return (
      <Feature
        onClick={() => this.props.onMarkerClick(id)}
        key={`feature-${id}`}
        coordinates={position}
      />
    );
  }

  renderCenterMarker() {
    return (
      <Layer key="layer-center" type="symbol" before="item-layer" layout={this.centerLayout}>
        <Feature key="feature-center" coordinates={this.centerPointPosition()} />
      </Layer>
    );
  }

  renderActivePopup() {
    const activeItem = this.findActiveItem();

    if (activeItem) {
      const position = [activeItem.longitude, activeItem.latitude];
      const label = activeItem.name;

      return (
        <Popup coordinates={position}>{label}</Popup>
      );
    }

    return null;
  }

  renderMarkers() {
    const items = this.itemsWithPositions();

    return items.map((item) => {
      const position = [item.longitude, item.latitude];
      return this.renderMarker(item.id, position);
    });
  }

  render() {
    const { center, centerMapAroundPoints } = this.state;

    let fitBoundsOptions = {};
    if (this.itemsWithPositions().length > 0) {
      fitBoundsOptions = {
        fitBounds: centerMapAroundPoints,
        fitBoundsOptions: { padding: 20 },
      };
    }

    return (
      <div className="map-explorer__map__container">
        <div style={{ height: '100%' }}>
          <ConfiguredMapboxGl
            onStyleLoad={map => this.onStyleLoad(map)}
            style={MapboxStyle}
            containerStyle={{ height: '100%', width: '100%' }}
            movingMethod="easeTo"
            {...fitBoundsOptions}
            center={center}
          >
            <ZoomControl position="top-left" />
            <Layer
              id="item-layer"
              type="symbol"
              layout={this.markerLayout}
            >
              {this.renderMarkers()}
            </Layer>
            {this.renderActivePopup()}
            {this.renderCenterMarker()}
          </ConfiguredMapboxGl>
        </div>
      </div>
    );
  }
}

Map.defaultProps = {
  selectedItemId: null,
  items: [],
};

Map.propTypes = {
  onZoomChanged: PropTypes.func.isRequired,
  onMarkerClick: PropTypes.func.isRequired,
  selectedItemId: PropTypes.number,
  centerPoint: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    iconUrl: PropTypes.string.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  })),
}

export default Map;
